<template>
  <div>
    <el-row v-loading="isLoadingCurrentSettings">
      <el-col>
        <el-card shadow="never">
          <h2><strong>Current Settings</strong></h2>
          <el-row
            style="text-align: center;"
            :gutter="10"
          >
            <el-col :md="8">
              <h3>Logo</h3>
              <img
                v-if="currentAccount && currentAccount.tracking_logo && currentAccount.tracking_logo.file"
                :src="$file.link(currentAccount.tracking_logo.file.id, true)"
                style="max-width: 100%; max-height: 250px;"
                alt=""
              >
              <p v-else>
                <el-tag>Default</el-tag>
              </p>
            </el-col>
            <el-col :md="8">
              <h3>Background</h3>
              <img
                v-if="currentAccount && currentAccount.tracking_background && currentAccount.tracking_background.file"
                :src="$file.link(currentAccount.tracking_background.file.id, true)"
                style="max-width: 100%; max-height: 250px;"
                alt=""
              >
              <p v-else>
                <el-tag>Default</el-tag>
              </p>
            </el-col>
            <el-col :md="8">
              <el-row
                :gutter="10"
                style="text-align: center;"
              >
                <el-col :md="12">
                  <h3>Heading</h3>
                  <p><el-tag>{{ currentAccount && currentAccount.tracking_heading ? currentAccount.tracking_heading : 'Default' }}</el-tag></p>
                </el-col>
                <el-col :md="12">
                  <h3>Theme</h3>
                  <p><el-tag>{{ currentAccount && currentAccount.tracking_theme ? currentAccount.tracking_theme : 'Default' }}</el-tag></p>
                </el-col>
              </el-row>
              <el-row
                :gutter="10"
                style="margin-top: 20px;"
              >
                <el-col :md="12">
                  <h3>Link</h3>
                  <p><el-tag>{{ currentAccount && currentAccount.tracking_logo_link ? currentAccount.tracking_logo_link : 'Default' }}</el-tag></p>
                </el-col>
                <el-col :md="12">
                  <h3>Position</h3>
                  <p><el-tag>{{ currentAccount && currentAccount.trakcing_logo_position ? currentAccount.tracking_logo_position : 'Default' }}</el-tag></p>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-col :md="{span: 8, offset: 8}">
              <el-row :gutter="10">
                <el-col :md="12">
                  <el-button
                    class="w-100"
                    @click.native="clearSettings()"
                  >
                    Clear Settings
                  </el-button>
                </el-col>
                <el-col :md="12">
                  <el-button
                    type="primary"
                    class="w-100"
                    @click.native="toPreview()"
                  >
                    Preview
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <br>
    <el-row>
      <el-col>
        <el-card shadow="never">
          <h2><strong>Edit Settings</strong></h2>
          <el-row
            style="text-align: center;"
            :gutter="10"
          >
            <el-col :md="8">
              <el-card
                shadow="never"
                :body-style="{ padding: '0px' }"
              >
                <h2 class="card-heading">
                  Step One
                </h2>
                <div class="card-content">
                  <p>Click the [Builder] button below to build your customised Track My Parcel, or Copy the link and paste it in your browser.</p>
                  <el-row :gutter="10">
                    <el-col :md="12">
                      <el-button
                        v-clipboard:copy="buildUrl"
                        v-clipboard:success="() => $message({ message: 'Copied to clipboard', type: 'success' })"
                        v-clipboard:error="() => $message({ message: 'An error occurred while copying the builder link', type: 'error' })"
                        class="w-100"
                      >
                        Copy Link
                      </el-button>
                    </el-col>
                    <el-col :md="12">
                      <el-button
                        type="primary"
                        style="margin-bottom: 10px; width: 100%;"
                        @click.native="toBuilder()"
                      >
                        Builder
                      </el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-col>
            <el-col :md="8">
              <el-card
                shadow="never"
                :body-style="{ padding: '0px' }"
              >
                <h2 class="card-heading">
                  Step Two
                </h2>
                <div class="card-content">
                  <p v-if="!jsonFile">
                    Drag or click upload to upload the .JSON file you've generated from Step One, then click [Save] to save your settings.
                  </p>
                  <el-upload
                    v-if="!jsonFile"
                    ref="uploader"
                    drag
                    :accept="'.json'"
                    :auto-upload="false"
                    :on-change="onFileChange"
                    :action="''"
                  >
                    <i class="el-icon-upload" />
                    <div class="el-upload__text">
                      Drop your JSON file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                  <div
                    v-if="logo"
                    class="property-gap"
                  >
                    <h3>Logo</h3>
                    <img
                      :src="`data:image/${logo.type};base64,${logo.contents}`"
                      style="max-width: 100%; max-height: 250px;"
                    >
                  </div>
                  <div
                    v-if="background"
                    class="property-gap"
                  >
                    <h3>Background</h3>
                    <img
                      :src="`data:image/${background.type};base64,${background.contents}`"
                      style="max-width: 100%; max-height: 250px;"
                    >
                  </div>
                  <el-row :gutter="10">
                    <el-col :md="12">
                      <div
                        v-if="heading"
                        class="property-gap"
                      >
                        <h3>Heading</h3>
                        <p><el-tag>{{ heading }}</el-tag></p>
                      </div>
                    </el-col>
                    <el-col :md="12">
                      <div
                        v-if="theme"
                        class="property-gap"
                      >
                        <h3>Theme</h3>
                        <p><el-tag>{{ theme }}</el-tag></p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :md="12">
                      <div
                        v-if="url"
                        class="property-gap"
                      >
                        <h3>Link</h3>
                        <p><el-tag>{{ url }}</el-tag></p>
                      </div>
                    </el-col>
                    <el-col :md="12">
                      <div
                        v-if="position"
                        class="property-gap"
                      >
                        <h3>Position</h3>
                        <p><el-tag>{{ position }}</el-tag></p>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    v-if="jsonFile"
                    :gutter="10"
                    style="margin-top: 10px;"
                  >
                    <el-col :md="12">
                      <el-button
                        class="w-100"
                        @click.native="reset()"
                      >
                        Reset
                      </el-button>
                    </el-col>
                    <el-col :md="12">
                      <el-button
                        type="primary"
                        class="w-100"
                        :loading="isLoading"
                        @click.native="save()"
                      >
                        Save
                      </el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-col>
            <el-col :md="8">
              <el-card
                shadow="never"
                :body-style="{ padding: '0px' }"
              >
                <h2 class="card-heading-inverse">
                  Attachments
                </h2>
                <div class="card-content">
                  <p>Alternatively, you can select any image from your existing attachments and set them as Logo and Background.</p>
                  <h3>Logo</h3>
                  <el-select
                    v-model="selectedLogo"
                    value-key="id"
                    placeholder="Select a Logo"
                    class="w-100"
                    clearable
                  >
                    <el-option
                      v-for="attachment in attachments"
                      :key="attachment.id"
                      :label="attachment.file ? attachment.file.name : 'No Name'"
                      :value="attachment"
                    />
                  </el-select>
                  <h3>Background</h3>
                  <el-select
                    v-model="selectedBackground"
                    value-key="id"
                    placeholder="Select a Background"
                    class="w-100"
                    clearable
                  >
                    <el-option
                      v-for="attachment in attachments"
                      :key="attachment.id"
                      :label="attachment.file ? attachment.file.name : 'No Name'"
                      :value="attachment"
                    />
                  </el-select>
                  <el-button
                    :disabled="(!selectedLogo && !selectedBackground)"
                    type="primary"
                    style="width: 100%; margin-top: 20px;"
                    :loading="isLoadingSaveAttachments"
                    @click.native="saveAttachments()"
                  >
                    Save
                  </el-button>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      jsonFile: null,
      logo: null,
      background: null,
      heading: '',
      theme: '',
      url: '',
      position: '',
      isLoading: false,
      isLoadingSaveAttachments: false,
      isLoadingCurrentSettings: false,
      currentAccount: null,
      attachments: null,
      selectedLogo: null,
      selectedBackground: null,
      buildUrl: ''
    }
  },
  watch: {
    jsonFile (newVal) {
      if (newVal) {
        var reader = new FileReader()
        reader.readAsText(newVal)
        setTimeout(() => {
          let tempJson = JSON.parse(reader.result)
          this.logo = tempJson.logo
          this.background = tempJson.background
          this.heading = tempJson.heading
          this.theme = tempJson.theme
          this.url = tempJson.url
          this.position = tempJson.position
        }, 100)
      }
    }
  },
  mounted () {
    this.loadCurrentSettings()
    this.loadAttachments()
  },
  methods: {
    loadCurrentSettings () {
      this.isLoadingCurrentSettings = true
      this.$sdk.account.read(this.accountId, builder => {
        builder.include = ['tracking_logo', 'tracking_background', 'acc_type']
      }).then(res => {
        this.currentAccount = res
        this.buildUrl = `https://${(this.currentAccount && this.currentAccount.acc_type && this.currentAccount.acc_type.desc === 'B2C Account') ? 'b2ctracking' : 'trackmyparcel'}.com.au/builder/${this.accountId}`
      }).finally(() => {
        this.isLoadingCurrentSettings = false
      })
    },
    loadAttachments () {
      this.$sdk.attachment.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
      }).then(res => {
        this.attachments = res
      })
    },
    saveAttachments () {
      this.isLoadingSaveAttachments = true
      let bodyData = {
        tracking_logo: this.selectedLogo,
        tracking_background: this.selectedBackground
      }
      this.$sdk.account.update(this.accountId, bodyData, builder => {
      })
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isLoadingSaveAttachments = false
          this.loadCurrentSettings()
        })
    },
    reset () {
      this.jsonFile = null
      this.logo = null
      this.background = null
      this.heading = ''
      this.theme = ''
      this.url = ''
      this.position = ''
    },
    async save () {
      this.isLoading = true
      const logoUrl = this.logo ? `data:image/${this.logo.type};base64,${this.logo.contents}` : ''
      const backgroundUrl = this.background ? `data:image/${this.background.type};base64,${this.background.contents}` : ''

      const logoAttachment = logoUrl ? await this.uploadAttachmentByUrl(logoUrl, this.logo.name, this.logo.type) : null
      const backgroundAttachment = backgroundUrl ? await this.uploadAttachmentByUrl(backgroundUrl, this.background.name, this.background.type) : null
      let bodyData = {
        tracking_logo: logoAttachment,
        tracking_background: backgroundAttachment,
        tracking_heading: this.heading,
        tracking_theme: this.theme,
        tracking_logo_link: this.url,
        tracking_logo_position: this.position
      }
      this.$sdk.account.update(this.accountId, bodyData)
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isLoading = false
          this.loadCurrentSettings()
          this.loadAttachments()
        })
    },
    uploadAttachmentByUrl (imageUrl, imageName, imageType) {
      return new Promise((resolve, reject) => {
        if (!imageUrl) {
          reject(new Error('No image url provided'))
        }

        fetch(imageUrl)
          .then(res => res.blob())
          .then(blob => {
            let file = new File([blob], `${imageName}`, { type: `image/${imageType}` })
            this.$file.upload(file, 'tracking_services', imageName).then(res => {
              let uploadedFile = res.data.file
              this.$file.setAttachment(uploadedFile.id, this.accountId)
                .then(res => resolve(res))
                .catch(err => reject(err))
            })
          }).catch(err => reject(err))
      })
    },
    toBuilder () {
      window.open(this.buildUrl, '_blank')
    },
    toPreview () {
      window.open(`https://trackmyparcel.com.au/preview/${this.accountId}`, '_blank')
    },
    onFileChange (file, fileList) {
      this.$refs.uploader.clearFiles()
      this.jsonFile = file.raw
    },
    clearSettings () {
      this.$confirm('Are you sure to clear all settings?', 'Clear Settings', {
        confirmButtonText: 'Clear',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoadingCurrentSettings = true
        let _account = new this.$sdk.account()
        _account.id = this.accountId
        _account.tracking_logo = null
        _account.tracking_background = null
        _account.tracking_heading = null
        _account.tracking_theme = null
        _account.tracking_logo_link = null
        _account.tracking_logo_position = null
        _account.update()
          .then(() => this.$message({ message: 'Successfully cleared settings', type: 'success' }))
          .finally(() => {
            this.loadCurrentSettings()
          })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.highlight-text-background {
  background-color: #ffd3d3;
}
.property-gap {
  margin: 10px 0px 10px 0px;
}
.card-heading {
  background-color: #2e7bcc;
  color: white;
  padding: 20px 0px 20px 0px;
}
.card-heading-inverse {
  background-color: white;
  color: #2e7bcc;
  padding: 20px 0px 20px 0px;
  border-bottom: 1px solid #ebeef5;
}
.card-content {
  padding: 13px 20px 20px 20px;
}
</style>
